import { useState } from "react";
import type { GPGameTeamResponse, GPGamePlayerResponse } from "../../../types";

const generateEmptyPlayers = (count: number, teamId: number, isSubstitute = false): GPGamePlayerResponse[] =>
	Array.from({ length: count }, () => ({
		id: 0,
		playerId: 0,
		teamId,
		name: "",
		birthYear: null,
		position: null,
		positionKey: null,
		isSubstitute,
		rating: null,
		numberSign: null,
		goals: null,
		minutesPlayed: null,
		playerUrl: null,
		coachRating: null,
		photo: null,
		isAnonymized: false,
		gender: null,
	}));


export default function useTeamSheet(selectedTeam: GPGameTeamResponse) {
	const [updatedPlayers, setUpdatedPlayers] = useState(
		selectedTeam.players.filter((player) => !player.isSubstitute)
	);

	if (updatedPlayers.length < 11) {
		const missingCount = 11 - updatedPlayers.length;
		const newPlayers = generateEmptyPlayers(missingCount, selectedTeam.id, false);
		setUpdatedPlayers([...updatedPlayers, ...newPlayers]);
	}

	const [updatedSubstitutes, setUpdatedSubstitutes] = useState(
		selectedTeam.players.filter((player) => player.isSubstitute)
	);

	const handlePlayerChange = (index: number, field: keyof GPGamePlayerResponse, value: any) => {
		setUpdatedPlayers((players) => players.map((p, i) => (i === index ? { ...p, [field]: value } : p)));
	};

	const handleSubstituteChange = (index: number, field: keyof GPGamePlayerResponse, value: any) => {
		setUpdatedSubstitutes((subs) => subs.map((p, i) => (i === index ? { ...p, [field]: value } : p)));
	};

	const handlePlayerSelect = (index: number, selectedOption: any) => {
		handlePlayerChange(index, "playerId", selectedOption?.value || "");
		handlePlayerChange(index, "name", selectedOption?.label || "");
	};

	const handleSubstitutePlayerSelect = (index: number, selectedOption: any) => {
		handleSubstituteChange(index, "playerId", selectedOption?.value || "");
		handleSubstituteChange(index, "name", selectedOption?.label || "");
	};

	const addSubstitute = () => {
		setUpdatedSubstitutes((subs) => [...subs, generateEmptyPlayers(1, selectedTeam.id, true)[0]]);
	};

	const handleRemovePlayer = (index: number, isSubstitute: boolean) => {
		if (isSubstitute) {
			setUpdatedSubstitutes((subs) => subs.filter((_, i) => i !== index));
		} else {
			setUpdatedPlayers((players) =>
				players.map((p, i) =>
					i === index
						? { ...p, playerId: 0, name: "", numberSign: null, goals: null, position: null, isAnonymized: false }
						: p
				)
			);
		}
	};

	return { updatedPlayers, updatedSubstitutes, handlePlayerChange, handleSubstituteChange, handlePlayerSelect, handleSubstitutePlayerSelect, addSubstitute, setUpdatedPlayers, handleRemovePlayer };
}
